export enum LocalStorageKeys {
  ACTIVE_SCHOOL_GROUP = 'active_school_group',
  CURRENT_USER = 'current_user',
  DICTIONARY = 'dictionary',
  SETTINGS = 'settings',
  HAS_AGREED_TO_COOKIES = 'has-agreed-to-cookies',
  UNIQUE_ID = 'unique-id',
}
